module.exports = __webpack_public_path__ + "static/media/logoPUmais.58bae950.svg";